/* Native modal and Shopify customer form; no subscription API or extra library. */
(() => {
  'use strict';
  const modal = document.querySelector('[data-newsletter-popup]');
  const key = 'sunday-newsletter-v1';
  const preview = modal && modal.dataset.preview === 'true';
  const read = (storage, name) => { try { return window[storage].getItem(key + name); } catch (_) { return null; } };
  const save = (storage, name, value) => { try { window[storage].setItem(key + name, value); } catch (_) { /* Forms still work without storage. */ } };
  const remove = (storage, name) => { try { window[storage].removeItem(key + name); } catch (_) { /* Optional storage. */ } };
  const source = read('sessionStorage', '-pending');
  const hash = window.location.hash;
  const footerResponse = source === 'footer' || hash.startsWith('#SundayNewsletter-');
  const url = new URL(window.location.href);
  const accepted = url.searchParams.get('customer_posted') === 'true';
  document.querySelectorAll('.tf-newsletter__form').forEach(form => {
    form.addEventListener('submit', () => save('sessionStorage', '-pending', 'footer'));
  });
  const footerSuccess = document.querySelector('.tf-newsletter__success');
  if (footerSuccess) save('localStorage', '-subscribed', 'true');
  if (footerResponse && footerSuccess) {
    remove('sessionStorage', '-pending');
    footerSuccess.scrollIntoView({ block: 'center' });
    footerSuccess.focus({ preventScroll: true });
  }
  if (!modal || typeof modal.showModal !== 'function') return;
  let result = modal.querySelector('[data-newsletter-result]');
  // Shopify may return a success query instead of form.posted_successfully?.
  // A submit event alone is never treated as a successful subscription.
  if (!result && accepted && !footerResponse) {
    modal.querySelector('form').append(modal.querySelector('[data-newsletter-success-template]').content.cloneNode(true));
    result = modal.querySelector('[data-newsletter-result]');
  }
  if (!result && (source === 'popup' || source === 'true') && !footerResponse) {
    // Do not leave a returning visitor with a silent reset or invent a success.
    result = document.createElement('p');
    result.dataset.newsletterResult = 'unconfirmed';
    result.setAttribute('role', 'alert');
    result.textContent = 'We couldn’t confirm your signup. Please check for a confirmation email, or try again below.';
    modal.querySelector('form').append(result);
  }
  const ownResponse = !footerResponse && result;
  let previousFocus, timer;
  function open() {
    previousFocus = document.activeElement;
    modal.showModal();
    document.documentElement.classList.add('tf-newsletter-modal-open');
    // Focus close first to avoid opening the mobile keyboard over the offer.
    (ownResponse ? result : modal.querySelector('[data-newsletter-close]')).focus();
    if (!preview) {
      save('sessionStorage', '-seen', 'true');
      save('localStorage', '-last', String(Date.now()));
    }
  }
  modal.querySelectorAll('[data-newsletter-close]').forEach(button => button.addEventListener('click', () => modal.close()));
  modal.addEventListener('close', () => {
    document.documentElement.classList.remove('tf-newsletter-modal-open');
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  });
  modal.querySelector('form').addEventListener('submit', () => {
    save('sessionStorage', '-pending', 'popup');
    const button = modal.querySelector('[type="submit"]');
    button.textContent = 'Signing you up…';
    modal.querySelector('form').setAttribute('aria-busy', 'true');
  });
  if (ownResponse) {
    remove('sessionStorage', '-pending');
    if (result.dataset.newsletterResult === 'success') {
      save('localStorage', '-subscribed', 'true');
      modal.classList.add('is-success');
      modal.querySelector('#NewsletterPopupTitle').textContent = 'Thank you for signing up!';
      modal.querySelector('#NewsletterPopupDescription').hidden = true;
      modal.removeAttribute('aria-describedby');
      modal.querySelector('[data-newsletter-fields]').hidden = true;
      modal.querySelector('.tf-newsletter-popup__later').textContent = 'Continue browsing';
    }
    result.setAttribute('tabindex', '-1');
    open();
    return;
  }
  if (modal.dataset.auto === 'false' || footerResponse) return;
  const days = Number(modal.dataset.days) || 7;
  const last = Number(read('localStorage', '-last')) || 0;
  if (!preview && (read('localStorage', '-subscribed') || read('sessionStorage', '-seen') || Date.now() - last < days * 86400000)) return;
  function attempt() {
    if (!preview && modal.dataset.mobile === 'false' && matchMedia('(max-width: 749px)').matches) return;
    const active = document.activeElement;
    const otherDialog = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')).some(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    const busy = document.hidden || (active && active.matches('input,textarea,select,[contenteditable="true"]')) || otherDialog;
    if (busy) { timer = setTimeout(attempt, 2000); return; }
    open();
  }
  timer = setTimeout(attempt, preview ? 750 : Math.max(3, Number(modal.dataset.delay) || 12) * 1000);
  window.addEventListener('pagehide', () => clearTimeout(timer), { once: true });
})();
